import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
@Component({
  selector: 'app-pushlist',
  templateUrl: './pushlist.component.html',
  styleUrls: ['./pushlist.component.css']
})
export class PushlistComponent implements OnInit {
  @Output() notify = new EventEmitter<any>();
  power:number = 0;

  constructor(
    public httpClient: HttpClient,
  ){}

  ngOnInit(): void {
    this.init_list();
    this.power = Dep.auth.power_id;

  }

  search_model:string = '';
  sort_model:string = 'desc';
  order_model:string = 'id';
  data:any=[];
  check_user_info:any=-1;
  edit_data:any=[];
  loading:boolean=true;
  msg :string = '';
  mouse_obj:{start:number,end:number,select:number,target:number} = {start:0,end:0,select:0,target:0}
  pageobj:page = {page:0,count:10,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))

  type_list:menulist = []
  time_list:menulist = []

  view_relation_list:menulist = [{id:'-1',name:'不設限'},{id:'1',name:'推播對象看過推薦對象'},{id:'2',name:'推薦對象看過推播對象'},{id:'3',name:'相互看過'},{id:'4',name:'未建立關係'}]
  menu_now:string = '1';
  sub_now:string = '2';
  now:string = '1';
  search_type_id:string = '-1';
  hobby_list:menulist = [
    {id:'-1',name:'不設限'},
    {id:'1',name:'至少1個相同興趣'},
    {id:'2',name:'至少2個相同興趣'},
    {id:'3',name:'至少3個相同興趣'},
    {id:'4',name:'至少4個相同興趣'},
    {id:'5',name:'至少5個相同興趣'},
    {id:'6',name:'至少6個相同興趣'}
  ]
  day_list:menulist = [
    {id:'1',name:'星期一'},
    {id:'2',name:'星期二'},
    {id:'3',name:'星期三'},
    {id:'4',name:'星期四'},
    {id:'5',name:'星期五'},
    {id:'6',name:'星期六'},
    {id:'7',name:'星期日'}
  ]
  varable_list:menulist = [
    {id:'{{user_id}}',name:'推薦用戶名'},
    {id:'{{self_user_id}}',name:'收訊息用戶名'},
    {id:'{{user_age}}',name:'推薦人歲數'},
    // {id:'{{match_score}}',name:'兩人匹配度'}
  ]
  love_relation_list:menulist = [{id:'-1',name:'不設限'},{id:'1',name:'推播對象追蹤推薦對象'},{id:'2',name:'推薦對象追蹤推播對象'},{id:'3',name:'相互追蹤'},{id:'4',name:'未建立關係'}]
  age_list:menulist = [{id:'-1',name:'不設限'},{id:'1',name:'指定區間'},{id:'2',name:'年齡差'},{id:'3',name:'指定歲數'}]
  push_user_list:menulist = [{id:'-1',name:'不設限'},{id:'3',name:'男'},{id:'4',name:'女'},{id:'1',name:'男指定'},{id:'2',name:'女指定'}]
  menu_list:menulist = [
    {id:'1',name:'互動推播訊息'},
    {id:'2',name:'排程推播設定'}
  ]


  tcontent = [
    {title:'名稱',content:'name'},
    {title:'標題',content:'title_tpl'},
    {title:'訊息',content:'content_tpl'},
    {title:'是否啟用',content:'is_enable',type:3},
    {title:'導入頁面',content:'route_sign_name'},
    {title:'操作',content:'gg',type:3},
  ];

  tcontent_active = [
    {title:'名稱',content:'name'},
    {title:'標題',content:'title_tpl'},
    {title:'訊息',content:'content_tpl'},
    {title:'操作',content:'gg',type:3},
  ];

  ck_date(list,id){
    // console.log(list,id,this.edit_data);
    const index = this.edit_data.info.post_time.day.findIndex((v)=>{
      return v == id;
    })

    if(index==-1){
      list.push(id);
    }else{
      list.splice(index,1);
    }

  }

  choose(value:string){
    if(value=='1'){
      this.varable_list = [
        {id:'{{user_id}}',name:'推薦用戶名'},
        {id:'{{self_user_id}}',name:'收訊息用戶名'},
        {id:'{{user_age}}',name:'推薦人歲數'},
      ]
    }else{
      this.varable_list = [
        {id:'{{user_id}}',name:'推薦人'},
        {id:'{{self_user_id}}',name:'推播對象'},
        {id:'{{user_age}}',name:'推薦人歲數'},
        {id:'{{love_num}}',name:'動態點讚數'},
        {id:'{{match_score}}',name:'兩人匹配度'}
      ]
    }


    this.menu_now = value;
    this.pageobj.total_count = 0;
    this.pageobj = {page:0,count:10,total_count:0};
    this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));  
    this.init_list();  
  }


  init_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,
    search_type_id:this.search_type_id,
    search:this.search_model,
    sort:this.sort_model,
    menu_now:this.menu_now,
    order:this.order_model
  
    };
    this.httpClient.post<any>("/get_push_list.php",body).subscribe(res => {
      this.loading = false;
     
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('res',res);
      this.type_list = res.type_list;
      this.time_list = res.time_list;
      if(res.status){
        this.data = res.data
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  check_user(user_id){
    this.loading = true;
    const body = {
    search:user_id,  
    };
    this.httpClient.post<any>("/get_user_list.php",body).subscribe(res => {
      // console.log(res)
      this.loading = false;
      if(res.status){
        this.check_user_info = res.data[0];
      }else{
        this.check_user_info = -1;
      }
    });
  }

  add_new_title(){
    this.edit_data.muti_title.unshift({id:-1,title_tpl:'',content_tpl:'',pt_id:this.edit_data.id,status:1})
  }

  save(item,type){ // -1上下架  1多標題  2設定檔

 
    this.loading = true;
    let body = {type:type,data:item};
    if(this.menu_now=='2'){
       body = {type:type,data:item};
    }else{
       body = {type:3,data:item};
    }

    this.httpClient.post<any>("/update_push.php",body).subscribe(res => {
      this.loading = false;
      console.log('res',res);
      if(res.status){
        this.init_list();
      }
    });

  
  }


  select(event) {
    const start = event.target.selectionStart;
    const end = event.target.selectionEnd;
    this.mouse_obj.start = start;
    this.mouse_obj.end = end;
 }

 add_var(item){
  if(this.menu_now=='1'){
    console.log(this.mouse_obj.target );
    const prestr = this.edit_data.content_tpl.substr(0,this.mouse_obj.start);
    const aftstr = this.edit_data.content_tpl.substr(this.mouse_obj.end)
     this.edit_data.content_tpl = `${prestr}${item}${aftstr}`
  }else{
    const select_key = this.mouse_obj.target == 0 ? 'title_tpl':'content_tpl';
    const prestr = this.edit_data.muti_title[this.mouse_obj.select][select_key].substr(0,this.mouse_obj.start)
    const aftstr = this.edit_data.muti_title[this.mouse_obj.select][select_key].substr(this.mouse_obj.end)
    this.edit_data.muti_title[this.mouse_obj.select][select_key] = `${prestr}${item}${aftstr}`
  }
 }
}
